import { Entry } from './entry';

Entry.displayName = 'SafeAreaView';

export { Entry as SafeAreaView };
export type { Props as SafeAreaViewProps } from './types';
